
import React, { useEffect, useState } from "react";
import classnames from "classnames";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    Table,
    Container,
    Row,
    Col,
    UncontrolledTooltip,
    UncontrolledAlert,
    Modal,
    CardBody,
    Form,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    Input,
    InputGroupText,
    ModalBody,
    ModalHeader,
    Pagination, PaginationItem, PaginationLink,
} from "reactstrap";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { getAllCustomers, deleteCustomer, updateCustomer } from "api/customerApiCall";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useTranslation } from '../../../i18n/context';

function Customers() {
    const [formModal, setFormModal] = React.useState(false);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [allCustomers, setAllCustomers] = useState([]);
    const [yourName, setYourName] = React.useState(false);
    const [customerEmail, setEmailAddress] = React.useState(false);
    const [phoneNumber, setPhoneNumber] = React.useState(false);
    const [customerCountry, setCustomerCountry] = React.useState(false);
    const [customerTown, setCustomerTown] = React.useState(false);
    const [customerAddress, setCustomerAddress] = React.useState(false);
    const [allCustomersError, setAllCustomersError] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [tooltipIds, setTooltipIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const navigate = useNavigate();
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [isDateFilterActive, setIsDateFilterActive] = useState(false);
    const { t } = useTranslation();


    const francophoneCountries = [
        { code: 'gh', name: 'Ghana', dialCode: '233' },
        { code: 'BEN', name: 'Benin', dialCode: '229' },
        { code: 'TZA', name: 'Tanzania', dialCode: '255' },
        { code: 'BFA', name: 'Burkina Faso', dialCode: '226' },
        { code: 'BDI', name: 'Burundi', dialCode: '257' },
        { code: 'CMR', name: 'Cameroon', dialCode: '237' },
        { code: 'CAN', name: 'Canada', dialCode: '1' },
        { code: 'CAF', name: 'Central African Republic', dialCode: '236' },
        { code: 'TCD', name: 'Chad', dialCode: '235' },
        { code: 'COM', name: 'Comoros', dialCode: '269' },
        { code: 'COG', name: 'Congo', dialCode: '242' },
        { code: 'COD', name: 'DR Congo', dialCode: '243' },
        { code: 'DJI', name: 'Djibouti', dialCode: '253' },
        { code: 'FRA', name: 'France', dialCode: '33' },
        { code: 'GUF', name: 'French Guiana', dialCode: '594' },
        { code: 'PYF', name: 'French Polynesia', dialCode: '689' },
        { code: 'GAB', name: 'Gabon', dialCode: '241' },
        { code: 'GIN', name: 'Guinea', dialCode: '224' },
        { code: 'HTI', name: 'Haiti', dialCode: '509' },
        { code: 'CIV', name: "Côte d'Ivoire", dialCode: '225' },
        { code: 'LUX', name: 'Luxembourg', dialCode: '352' },
        { code: 'MDG', name: 'Madagascar', dialCode: '261' },
        { code: 'MLI', name: 'Mali', dialCode: '223' },
        { code: 'MRT', name: 'Mauritania', dialCode: '222' },
        { code: 'MCO', name: 'Monaco', dialCode: '377' },
        { code: 'NER', name: 'Niger', dialCode: '227' },
        { code: 'ng', name: 'Nigeria', dialCode: '234' },
        { code: 'RWA', name: 'Rwanda', dialCode: '250' },
        { code: 'SEN', name: 'Senegal', dialCode: '221' },
        { code: 'SYC', name: 'Seychelles', dialCode: '248' },
        { code: 'TGO', name: 'Togo', dialCode: '228' },
        { code: 'VUT', name: 'Vanuatu', dialCode: '678' }
    ];


    useEffect(() => {
        if (Array.isArray(allCustomers)) {
            const ids = allCustomers.map((_, index) => ({
                edit: `tooltipEdit${index}`,
                delete: `tooltipDelete${index}`,
            }));
            setTooltipIds(ids);
        } else {
            console.warn('allCustomers is not an array:', allCustomers);
        }
    }, [allCustomers]);

    // useEffect(() => {

    //     const results = allCustomers.filter(customer =>
    //         customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
    //     );
    //     setFilteredCustomers(results);
    //     setCurrentPage(1);
    // }, [searchTerm, allCustomers]);


    useEffect(() => {
        let results = allCustomers;

        // Filter by customer name if search term exists
        if (searchTerm) {
            results = results.filter(customer =>
                customer.customer_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Apply date filter if active
        if (isDateFilterActive && startDate && endDate) {
            const startDateTime = new Date(startDate).setHours(0, 0, 0, 0);
            const endDateTime = new Date(endDate).setHours(23, 59, 59, 999);

            results = results.filter(customer => {
                const customerDate = new Date(customer.createdAt).getTime();
                return customerDate >= startDateTime && customerDate <= endDateTime;
            });
        }

        setFilteredCustomers(results);
        setCurrentPage(1);
    }, [searchTerm, allCustomers, startDate, endDate, isDateFilterActive]);

    const applyDateFilter = () => {
        setIsDateFilterActive(true);
    };

    // Add handler for clearing date filter
    const clearDateFilter = () => {
        setStartDate('');
        setEndDate('');
        setIsDateFilterActive(false);
    };

    const getCountryDialCode = (countryName) => {
        const country = francophoneCountries.find(c => c.name === countryName);
        return country ? country.dialCode : '';
    };

    const formatPhoneNumber = (phone, country) => {
        const dialCode = getCountryDialCode(country);
        if (!phone) return '';
        if (!dialCode) return phone;
        return `${dialCode} ${phone}`;
    };


    const toggleModal = () => {
        setFormModal(!formModal);
    };

    const handleEditClick = (customerData) => {
        setSelectedCustomer(customerData);
        toggleModal();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const [errorCustomersCall, successUserCall] = await updateCustomer(selectedCustomer);
            if (errorCustomersCall) {
                setErrorMessages(errorCustomersCall.message);
                setShowErrorAlert(true);
            } else {
                setShowSuccessAlert(true);
                window.location.reload();
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        }
    };

    //Delete
    const handleDeleteClick = (customerId) => {
        Swal.fire({
            title: t('category.sure'),
            text: t('category.delete_text'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('category.delete_confirm')
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCustomer(customerId)
                    .then(([error, successData]) => {
                        if (error) {
                            Swal.fire(
                                t('profile.error'),
                                error.message || t('customer.not_successful'),
                                'error'
                            );
                        } else {
                            Swal.fire(
                                t('profile.delete_success_title'),
                                t('customer.deleted'),
                                'success'
                            ).then(() => {
                                window.location.reload();
                            });
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            t('profile.error'),
                            t('category.delete_error_title'),
                            'error'
                        );
                    });
            }
        });
    };

    const fetchCustomers = async () => {
        const [errorCustomersCall, successCustomerCall] = await getAllCustomers({});
        if (errorCustomersCall || !successCustomerCall) {
            // show error messge
            setAllCustomersError(errorCustomersCall)
        } else {
            setAllCustomers(successCustomerCall)
        }

    }
    useEffect(() => {
        fetchCustomers();
    }, [])

    useEffect(() => {
        const timeOutError = setTimeout(() => {
            setAllCustomersError({});
        }, 10000)
        return () => {
            clearTimeout(timeOutError);
        }
    }, [allCustomersError])

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    return (
        <>
            <SimpleHeader name={t('customer.management')} />
            <Container className="mt--6" fluid>
                <Card>
                    <CardHeader className="border-0">
                        <Row>
                            <Col xs="6">
                                <h3 className="mb-0">{t('customer.customers')}</h3>
                            </Col>
                            <Col className="text-right" xs="6">
                                <Button
                                    className="btn-round btn-icon"
                                    color="primary"
                                    id="tooltip443412080"
                                    onClick={() => navigate('/admin/addcustomers')}
                                    size="sm"
                                >
                                    <span className="btn-inner--icon mr-1">
                                        <i className="fas fa-user-edit" />
                                    </span>
                                    <span className="btn-inner--text">{t('customer.add_customer')}</span>
                                </Button>
                                <UncontrolledTooltip delay={0} target="tooltip443412080">
                                    {t('customer.add_customer')}
                                </UncontrolledTooltip>
                            </Col>
                        </Row>
                    </CardHeader>
                    <div className="px-3 py-2">
                        <Row>
                            <Col md="6">
                                <Input
                                    type="text"
                                    placeholder={t('invoice.search')}
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                />
                            </Col>
                            <Col md="6">
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Input
                                                type="date"
                                                placeholder="Start Date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Input
                                                type="date"
                                                placeholder="End Date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup className="d-flex">
                                            <Button
                                                color="primary"
                                                size="sm"
                                                onClick={applyDateFilter}
                                                className="mr-2"
                                                disabled={!startDate || !endDate}
                                            >
                                                <i className="fas fa-filter mr-1"></i>
                                                {t('invoice.filter')}
                                            </Button>
                                            {isDateFilterActive && (
                                                <Button
                                                    color="secondary"
                                                    size="sm"
                                                    onClick={clearDateFilter}
                                                >
                                                    <i className="fas fa-times mr-1"></i>
                                                    {t('invoice.clear')}
                                                </Button>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    {allCustomers && allCustomers.length > 0 && (
                        <div className="table-responsive">
                            <Table className="align-items-center table-flush" responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th>{t('profile.name')}</th>
                                        <th>Email</th>
                                        <th>{t('customer.address')}</th>
                                        <th>{t('customer.country')}</th>
                                        <th>{t('common.phone')}</th>
                                        <th>Action</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody className="list">
                                    {currentItems.map((customerData, index) => (
                                        <tr key={index}>
                                            <td>{customerData?.customer_name}</td>
                                            <td>{customerData?.customer_email}</td>
                                            <td>{customerData?.customer_address}</td>
                                            <td>{customerData?.customer_country}</td>
                                            <td>{formatPhoneNumber(customerData?.customer_phone, customerData?.customer_country)}</td>
                                            <td className="table-actions">
                                                <a
                                                    className="table-action"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.edit}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleEditClick(customerData);
                                                    }}
                                                >
                                                    <i className="fas fa-user-edit" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].edit}>
                                                        {t('profile.edituser')}
                                                    </UncontrolledTooltip>
                                                )}
                                                <a
                                                    className="table-action table-action-delete"
                                                    href="#pablo"
                                                    id={tooltipIds[index]?.delete}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleDeleteClick(customerData._id);
                                                    }}
                                                >
                                                    <i className="fas fa-trash" />
                                                </a>
                                                {tooltipIds[index] && (
                                                    <UncontrolledTooltip delay={0} target={tooltipIds[index].delete}>
                                                        {t('profile.deleteuser')}
                                                    </UncontrolledTooltip>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}


                    <div className="card-footer py-4">
                        <Pagination>
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink previous onClick={() => paginate(currentPage - 1)} />
                            </PaginationItem>
                            {[...Array(Math.ceil(filteredCustomers.length / itemsPerPage))].map((_, index) => (
                                <PaginationItem key={index} active={index + 1 === currentPage}>
                                    <PaginationLink onClick={() => paginate(index + 1)}>
                                        {index + 1}
                                    </PaginationLink>
                                </PaginationItem>
                            ))}
                            <PaginationItem disabled={currentPage === Math.ceil(filteredCustomers.length / itemsPerPage)}>
                                <PaginationLink next onClick={() => paginate(currentPage + 1)} />
                            </PaginationItem>
                        </Pagination>
                    </div>
                </Card>
            </Container>

            <Modal className="modal-dialog-centered" size="sm" isOpen={formModal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{t('customer.edit_customer')}</ModalHeader>
                <ModalBody>
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="px-lg-5 py-lg-0">
                            <div className="text-center text-muted mb-4">
                                <small>{t('customer.edit_customer_details')}</small>
                            </div>
                            {showSuccessAlert && (
                                <UncontrolledAlert color="success">
                                    <span className="alert-text ml-1">
                                        <strong>{t('profile.success')}</strong> {t('customer.updated')}
                                    </span>
                                </UncontrolledAlert>
                            )}

                            {showErrorAlert && (
                                <UncontrolledAlert color="danger">
                                    <span className="alert-text ml-1">
                                        <strong>{t('profile.error')}</strong>
                                    </span>
                                </UncontrolledAlert>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: yourName })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-user" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder={t('profile.name')}
                                                    type="text"
                                                    value={selectedCustomer.customer_name || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_name: e.target.value })}
                                                    required
                                                    onFocus={() => setYourName(true)}
                                                    onBlur={() => setYourName(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: customerEmail })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-envelope" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Email"
                                                    type="email"
                                                    value={selectedCustomer.customer_email || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_email: e.target.value })}
                                                    required
                                                    onFocus={() => setEmailAddress(true)}
                                                    onBlur={() => setEmailAddress(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: phoneNumber })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-phone" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Phone number"
                                                    type="text"
                                                    value={selectedCustomer.customer_phone || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_phone: e.target.value })}
                                                    required
                                                    onFocus={() => setPhoneNumber(true)}
                                                    onBlur={() => setPhoneNumber(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: customerAddress })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-address-book" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Address"
                                                    type="text"
                                                    value={selectedCustomer.customer_address || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_address: e.target.value })}
                                                    required
                                                    onFocus={() => setCustomerAddress(true)}
                                                    onBlur={() => setCustomerAddress(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md="12">
                                        <FormGroup>
                                            <InputGroup className={classnames("input-group-merge", { focused: customerTown })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-tower-observation" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Town"
                                                    type="text"
                                                    value={selectedCustomer.customer_town || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_town: e.target.value })}
                                                    onFocus={() => setCustomerTown(true)}
                                                    onBlur={() => setCustomerTown(false)}
                                                />
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>

                                            <InputGroup className={classnames("input-group-merge", { focused: customerCountry })}>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>
                                                        <i className="fas fa-globe-americas" />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                                <Input
                                                    placeholder="Country"
                                                    type="text"
                                                    value={selectedCustomer.customer_country || ''}
                                                    onChange={(e) => setSelectedCustomer({ ...selectedCustomer, customer_country: e.target.value })}
                                                    onFocus={() => setCustomerCountry(true)}
                                                    onBlur={() => setCustomerCountry(false)}
                                                />

                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Button className="btn-icon" color="primary" type="submit">
                                    <span className="btn-inner--text">{t('profile.submit')}</span>
                                </Button>
                                <Button color="secondary" onClick={toggleModal}>{t('profile.cancel')}</Button>
                            </Form>
                        </CardBody>
                    </Card>
                </ModalBody>
            </Modal>
        </>
    );
}

export default Customers;
